"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _roles = _interopRequireDefault(require("./types/roles"));

var SettingsApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(SettingsApi, _BasicApi);

  /**
   * @constructor
   */
  function SettingsApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl;
    (0, _classCallCheck2.default)(this, SettingsApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SettingsApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.sdkApiUrl = sdkApiUrl;
    return _this;
  }

  (0, _createClass2.default)(SettingsApi, [{
    key: "accountSettingsUrl",
    value: function accountSettingsUrl(_ref2) {
      var accountId = _ref2.accountId,
          key = _ref2.key;

      if (accountId && key) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/account-settings/").concat(key);
      } else if (accountId) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/account-settings");
      } else if (key) {
        return "".concat(this.sdkApiUrl, "/account-settings/").concat(key);
      }

      return "".concat(this.sdkApiUrl, "/account-settings");
    }
  }, {
    key: "userSettingsUrl",
    value: function userSettingsUrl(_ref3) {
      var accountId = _ref3.accountId,
          userId = _ref3.userId,
          key = _ref3.key;

      if (accountId && userId && key) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/users/").concat(userId, "/user-settings/").concat(key);
      } else if (accountId && userId) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/users/").concat(userId, "/user-settings");
      } else if (userId && key) {
        return "".concat(this.sdkApiUrl, "/users/").concat(userId, "/user-settings/").concat(key);
      } else if (userId) {
        return "".concat(this.sdkApiUrl, "/users/").concat(userId, "/user-settings");
      } else if (key) {
        return "".concat(this.sdkApiUrl, "/user-settings/").concat(key);
      }

      return "".concat(this.sdkApiUrl, "/user-settings");
    }
  }, {
    key: "mergedSettingsUrl",
    value: function mergedSettingsUrl(_ref4) {
      var accountId = _ref4.accountId,
          userId = _ref4.userId,
          key = _ref4.key;

      if (accountId && userId && key) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/users/").concat(userId, "/settings/").concat(key);
      } else if (accountId && userId) {
        return "".concat(this.sdkApiUrl, "/accounts/").concat(accountId, "/users/").concat(userId, "/settings");
      } else if (userId && key) {
        return "".concat(this.sdkApiUrl, "/users/").concat(userId, "/settings/").concat(key);
      } else if (userId) {
        return "".concat(this.sdkApiUrl, "/users/").concat(userId, "/settings");
      } else if (key) {
        return "".concat(this.sdkApiUrl, "/settings/").concat(key);
      }

      return "".concat(this.sdkApiUrl, "/settings");
    }
  }, {
    key: "getRoleSettings",
    value: function getRoleSettings(role, payload) {
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      switch (role) {
        case _roles.default.SUPER_ADMIN:
        case _roles.default.ADMIN:
          return this.getAccountSettings.apply(this, [payload].concat(rest));

        case _roles.default.USER:
        case _roles.default.GUEST:
          return this.getUserSettings.apply(this, [payload].concat(rest));

        default:
          return _bluebird.default.reject('Role is not valid');
      }
    }
  }, {
    key: "setRoleSettings",
    value: function setRoleSettings(role, payload) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      switch (role) {
        case _roles.default.SUPER_ADMIN:
        case _roles.default.ADMIN:
          return this.setAccountSettings.apply(this, [payload].concat(rest));

        case _roles.default.USER:
        case _roles.default.GUEST:
          return this.setUserSettings.apply(this, [payload].concat(rest));

        default:
          return _bluebird.default.reject('Role is not valid');
      }
    }
  }, {
    key: "getAccountSettings",
    value: function () {
      var _getAccountSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref5) {
        var _this2 = this;

        var accountId, key, headers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accountId = _ref5.accountId, key = _ref5.key;
                _context.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context.sent;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(_this2.accountSettingsUrl({
                    accountId: accountId,
                    key: key
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (data) {
                  return key ? _lodash.default.get(data, 'value') : data;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAccountSettings(_x) {
        return _getAccountSettings.apply(this, arguments);
      }

      return getAccountSettings;
    }()
  }, {
    key: "getUserSettings",
    value: function () {
      var _getUserSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref6) {
        var _this3 = this;

        var accountId, userId, key, headers;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accountId = _ref6.accountId, userId = _ref6.userId, key = _ref6.key;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context2.sent;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(_this3.userSettingsUrl({
                    accountId: accountId,
                    userId: userId,
                    key: key
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (data) {
                  return key ? _lodash.default.get(data, 'value') : data;
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserSettings(_x2) {
        return _getUserSettings.apply(this, arguments);
      }

      return getUserSettings;
    }()
  }, {
    key: "getMergedSettings",
    value: function () {
      var _getMergedSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref7) {
        var _this4 = this;

        var accountId, userId, key, headers;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                accountId = _ref7.accountId, userId = _ref7.userId, key = _ref7.key;
                _context3.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context3.sent;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(_this4.mergedSettingsUrl({
                    accountId: accountId,
                    userId: userId,
                    key: key
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (data) {
                  return key ? _lodash.default.get(data, 'value') : data;
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMergedSettings(_x3) {
        return _getMergedSettings.apply(this, arguments);
      }

      return getMergedSettings;
    }()
  }, {
    key: "setAccountSettings",
    value: function () {
      var _setAccountSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref8) {
        var _this5 = this;

        var accountId, key, value, headers;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                accountId = _ref8.accountId, key = _ref8.key, value = _ref8.value;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context4.sent;
                return _context4.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post(_this5.accountSettingsUrl({
                    accountId: accountId,
                    key: key
                  }), value, headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (data) {
                  return key ? _lodash.default.get(data, 'value') : data;
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setAccountSettings(_x4) {
        return _setAccountSettings.apply(this, arguments);
      }

      return setAccountSettings;
    }()
  }, {
    key: "setUserSettings",
    value: function () {
      var _setUserSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref9) {
        var _this6 = this;

        var accountId, userId, key, value, headers;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                accountId = _ref9.accountId, userId = _ref9.userId, key = _ref9.key, value = _ref9.value;
                _context5.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context5.sent;
                return _context5.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post(_this6.userSettingsUrl({
                    accountId: accountId,
                    userId: userId,
                    key: key
                  }), value, headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (data) {
                  return key ? _lodash.default.get(data, 'value') : data;
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setUserSettings(_x5) {
        return _setUserSettings.apply(this, arguments);
      }

      return setUserSettings;
    }()
  }, {
    key: "deleteAccountSettings",
    value: function () {
      var _deleteAccountSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref10) {
        var _this7 = this;

        var accountId, key, headers;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                accountId = _ref10.accountId, key = _ref10.key;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context6.sent;
                return _context6.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete(_this7.accountSettingsUrl({
                    accountId: accountId,
                    key: key
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteAccountSettings(_x6) {
        return _deleteAccountSettings.apply(this, arguments);
      }

      return deleteAccountSettings;
    }()
  }, {
    key: "deleteUserSettings",
    value: function () {
      var _deleteUserSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref11) {
        var _this8 = this;

        var accountId, userId, key, headers;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                accountId = _ref11.accountId, userId = _ref11.userId, key = _ref11.key;
                _context7.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context7.sent;
                return _context7.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete(_this8.accountSettingsUrl({
                    accountId: accountId,
                    userId: userId,
                    key: key
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteUserSettings(_x7) {
        return _deleteUserSettings.apply(this, arguments);
      }

      return deleteUserSettings;
    }()
  }]);
  return SettingsApi;
}(_basic.default);

var _default = SettingsApi;
exports.default = _default;